import debounce from "../../../utils/debounce";
import { isErrorDispaly } from "../../../shared/validationsAndExceptions/apiExceptions";
import { getTransactionGridDetils } from "./api";

export const getTransactionGrid = async (id,search,callback,pageNo,pageSize,type,wallet,selectedDates) => {
  pageSize = pageSize ||20;
  let _fromDate = selectedDates?.length > 0 ? selectedDates[0] :'' ;
  let _toDate = selectedDates?.length > 0 ? selectedDates[1] :'';
    const response = await getTransactionGridDetils(id,type,wallet,search,_fromDate,_toDate,pageNo,pageSize);
    if (response.ok) {
      callback(response.data,null)
    } else {
      callback(null,isErrorDispaly(response))
    }
  };
  export const debouncedGrid=debounce(getTransactionGrid)